<div class="app-admin-wrap layout-auth-bg">
	<div class="auth-layout-wrap">
		<div class="auth-content">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
